import { rem } from 'polished';
import styled from 'styled-components';

const AddColorDefaultModalContent = styled.div`
    padding: ${rem(16)} 0;
`;

export default AddColorDefaultModalContent;
